import React, { useContext, useEffect, useRef, useState } from "react";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import TitleBar from "../../components/layout-components/TitleBar";
import { ReactComponent as RefreshIcon } from "../../assets/images/refresh_icon.svg";
import { ReactComponent as ExportIcon } from "../../assets/images/ralvie/export-icon.svg";
import CustomIconButton from "../../components/CustomIconButton";
import { Box, Tooltip, useMediaQuery, Popover } from "@mui/material";
import AppContext from "../../config/AppContext";
import { useTheme } from "@mui/material/styles";
import "./UsageInsight.scss";
import UsageOverwiew from "./UsageOverwiew";
import WorkingScore from "./ProjectScore";
import UsageDataTable from "./UsageDataTable";
import { ReactComponent as ProfileIcon } from "../../assets/images/insight-profile.svg";
import TimesheetDatePickerWOB from "../timesheet/TimesheetDatePickerWOB";
import DepartmentFilter from "../dashboard/DepartmentFilter";
import { exportMemberActivityReport, exportUserActivationDetailsReport, exportUsersByStatus, exportUsersUsageRate, exportWorklogCreators } from "../../services/UsageInsightService";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

const UsageInsight = () => {
    const { t } = useTranslation();
    const { mode } = useContext(AppContext);
    const theme = useTheme();
    const timeRef = useRef();
    const [selectedDate, setSelectedDate] = useState(dayjs());
    const isXlScreen = useMediaQuery(theme.breakpoints.up("xl"));
    const [refresh, setRefresh] = useState(false);
    const [departmentFilter, setDepartmentFilter] = useState(["All departments"]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [open, setOpen] = useState(false);
    const [exportType, setExportType] = useState("");
   
    const resetFilter = () => {
        setSelectedDate(dayjs());
        setRefresh(true);
        setDepartmentFilter(["All departments"])
    };

    const handleExportClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClosePopover = () => {
        setAnchorEl(null);
    };

    const handleClickOpen = async (type) => {
    handleClosePopover();

    try {
        const localTz = dayjs.tz.guess();
        const startDate = dayjs(selectedDate).tz(localTz).startOf("day").utc().format("YYYY-MM-DDTHH:mm:ss[Z]");
        const endDate = dayjs(selectedDate).tz(localTz).endOf("day").utc().format("YYYY-MM-DDTHH:mm:ss[Z]");

        switch (type) {

            // case "active-users":
            //     await exportUsersByStatus("ACTIVE");
            //     break;
            // case "inactive-users":
            //     await exportUsersByStatus("INACTIVE");
            //     break;
            // case "usage-rate":
            //     await exportUsersUsageRate(startDate, endDate);
            //     break;
            // case "worklog-creators":
            //     await exportWorklogCreators(startDate, endDate);
            //     break;

            case "user-activation-details-report":
                await exportUserActivationDetailsReport();
                break;
            case "member-activity-rank":
                await exportMemberActivityReport(startDate, endDate);
                break;
            default:
                setExportType(type);
                setOpen(true);
        }
    } catch (error) {
        console.error("Export failed:", error);
    }
};

    const openPopover = Boolean(anchorEl);
    const popupMore = {
        id: openPopover ? 'simple-popover' : undefined,
    };

    return (
        <div>
            <div className="insights-sub-components">
                <div>
                    <TitleBar
                        id="header-text-add-project"
                        title={t("RAL1216")}
                    ></TitleBar>
                </div>
                <div className="insights-sub-components1">
                    <TimesheetDatePickerWOB
                        ref={timeRef}
                        selectedDate={selectedDate}
                        onChange={(newDate) => setSelectedDate(newDate)}
                    />
                    <Box item pl={1}>
                        <Box
                            sx={{
                                "& .refresh_svg": {
                                    transition: "color 0.3s ease",
                                    color: mode === "dark" ? "var(--color-33-50)" : "#242424cc",
                                },
                                "&:hover": {
                                    "& .hover-text, & .refresh_svg": {
                                        color: mode === "dark" ? "#f8f8f8cc" : "#242424",
                                    },
                                },
                            }}
                        >
                            <CustomIconButton
                                id="btn-refresh-project"
                                title={t("RAL0169")}
                                size={isXlScreen ? "large" : "md"}
                                variant="square"
                                lightMode={
                                    <RefreshIcon
                                        id="member-refresh-icon"
                                        className="refresh_svg"
                                        height={isXlScreen ? "18px" : "14px"}
                                    />
                                }
                                darkMode={
                                    <RefreshIcon
                                        id="member-refresh-icon"
                                        className="refresh_svg"
                                        height={isXlScreen ? "18px" : "14px"}
                                    />
                                }
                                onClick={() => resetFilter()}
                            />
                        </Box>
                    </Box>

                    <Box item pl={2}>
                        <CustomIconButton
                            id="btn-custom-export-project"
                            name="btn-custom-export-project"
                            title={t("RAL0973")}
                            size={isXlScreen ? "large" : "md"}
                            variant="square"
                            type="contained"
                            border={"none"}
                            lightMode={<ExportIcon height={isXlScreen ? "18px" : "14px"} />}
                            darkMode={<ExportIcon height={isXlScreen ? "18px" : "14px"} />}
                            onClick={handleExportClick}
                        />
                    </Box>
                </div>
            </div>

            <Popover
                {...popupMore}
                open={openPopover}
                anchorEl={anchorEl}
                onClose={handleClosePopover}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                PaperProps={{
                    sx: {
                        boxShadow: "0px 3px 6px rgba(0,0,0,0.12)",
                    },
                }}
            >
                <Box
                    py={1}
                    px={0}
                    sx={{
                        background: mode === "dark" ? "#101010" : "#ffffff",
                        color: mode === "dark" ? "#f8f8f8cc" : "#242424",
                        opacity: 1,
                    }}
                >
                   
                    {/* <Box
                        onClick={() => handleClickOpen("active-users")}
                        py={1}
                        px={2}
                        sx={{
                            cursor: "pointer",
                            "&:hover": {
                                background: mode === "dark" ? "#1e1e1e" : "#f5f5f5",
                            },
                        }}
                        id="btn-report-active-users"
                    >
                        {t("RAL1217")}
                    </Box>
                    <Box
                        onClick={() => handleClickOpen("inactive-users")}
                        py={1}
                        px={2}
                        sx={{
                            cursor: "pointer",
                            "&:hover": {
                                background: mode === "dark" ? "#1e1e1e" : "#f5f5f5",
                            },
                        }}
                        id="btn-report-inactive-users"
                    >
                        {t("RAL1218")}
                    </Box>
                    <Box
                        onClick={() => handleClickOpen("usage-rate")}
                        py={1}
                        px={2}
                        sx={{
                            cursor: "pointer",
                            "&:hover": {
                                background: mode === "dark" ? "#1e1e1e" : "#f5f5f5",
                            },
                        }}
                        id="btn-report-usage-rate"
                    >
                        {t("RAL1219")}
                    </Box>
                    <Box
                        onClick={() => handleClickOpen("worklog-creators")}
                        py={1}
                        px={2}
                        sx={{
                            cursor: "pointer",
                            "&:hover": {
                                background: mode === "dark" ? "#1e1e1e" : "#f5f5f5",
                            },
                        }}
                        id="btn-report-worklog-creators"
                    >
                        {t("RAL1220")}
                    </Box> */}

                    <Box
                        onClick={() => handleClickOpen("user-activation-details-report")}
                        py={1}
                        px={2}
                        sx={{
                            cursor: "pointer",
                            "&:hover": {
                                background: mode === "dark" ? "#1e1e1e" : "#f5f5f5",
                            },
                        }}
                        id="btn-report-user-activation-details-report"
                    >
                        {t("RAL1226")}
                    </Box>

                    <Box
                        onClick={() => handleClickOpen("member-activity-rank")}
                        py={1}
                        px={2}
                        sx={{
                            cursor: "pointer",
                            "&:hover": {
                                background: mode === "dark" ? "#1e1e1e" : "#f5f5f5",
                            },
                        }}
                        id="btn-report-member-activity-rank"
                    >
                        {t("RAL1221")}
                    </Box>
                </Box>
            </Popover>

            <div className="insights-component">
                <div className="insights-component1">
                    <UsageOverwiew
                        startDate={selectedDate}
                        endDate={selectedDate}
                    />
                    <div className={mode === "dark" ? "insights-component12-dark" : "insights-component12"}>
                        <div className="insights-component-member-ranking">
                            <span className={mode === "dark" ? "insights-component1-heading-dark" : "insights-component1-heading"}>{t("RAL1222")}</span>
                            <div className="insights-component1-filter">
                                <DepartmentFilter
                                    departmentFilter={departmentFilter}
                                    setDepartmentFilter={setDepartmentFilter}
                                />
                            </div>
                        </div>
                        <UsageDataTable selectedDate={selectedDate} departmentIds={departmentFilter} refresh={refresh} setRefresh={setRefresh} />
                    </div>
                </div>
                <div className="insights-component2">
                    <WorkingScore selectedDate={selectedDate} />
                </div>
            </div>
        </div>
    )
}

export default UsageInsight;